import { render } from "./BoxDetail.vue?vue&type=template&id=5e728bf6"
import script from "./BoxDetail.vue?vue&type=script&lang=js"
export * from "./BoxDetail.vue?vue&type=script&lang=js"

import "./BoxDetail.vue?vue&type=style&index=0&id=5e728bf6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__